export default class ForecastEstoqueConsumido {
  id: number;
  codigoFornecedorSap: number;
  numeroContrato: string;
  codigoSku: number;
  centro: number;
  percentualConsumido: number;
  quantidade: number;
  mesAnoReferencia: number;

  constructor(
    id: number,
    codigoFornecedorSap: number,
    numeroContrato: string,
    codigoSku: number,
    centro: number,
    quantidade: number,
    mesAnoReferencia: number
  ) {
    this.id = id;
    this.codigoFornecedorSap = codigoFornecedorSap;
    this.numeroContrato = numeroContrato;
    this.codigoSku = codigoSku;
    this.centro = centro;
    this.percentualConsumido = 0;
    this.quantidade = quantidade;
    this.mesAnoReferencia = mesAnoReferencia;
  }

  setPercentualConsumido(percentualConsumido: number): void {
    this.percentualConsumido = percentualConsumido;
  }

  static toJson(forecastEstoqueConsumido: ForecastEstoqueConsumido): string {
    return JSON.stringify(forecastEstoqueConsumido);
  }

  static fromJson(json: object[]): ForecastEstoqueConsumido[] {
    let forecastEstoqueConsumido: ForecastEstoqueConsumido[] = [];
    json.forEach((item: any) => {
      forecastEstoqueConsumido.push(
        new ForecastEstoqueConsumido(
          item["id"],
          item["codigoFornecedorSap"],
          item["numeroContrato"],
          item["codigoSku"],
          item["centro"],
          item["quantidade"],
          item["mesAnoReferencia"]
        )
      );
    });
    return forecastEstoqueConsumido;
  }
}
